<template>
    <div class="flex flex-col">
        <h2 class="text-2xl md:text-4xl font-semibold mb-6">
            Notable Diagnostic Tests Results: Imaging Tests and Biopsy
        </h2>

        <div class="flex flex-col md:flex-row gap-8">
            <div class="flex-1">
                <h3 class="text-2xl font-semibold mb-3">Kidney imaging and biopsy test results</h3>

                <p class=" font-light italic mb-3">Imaging</p>
                <ul class="list-disc pl-4  font-light mb-3">
                    <li>Ultrasound imaging showed normal-sized kidneys with a raised echo pattern</li>
                </ul>

                <p class=" font-light italic mb-3">Biopsy</p>
                <ul class="list-disc pl-4 font-light mb-6">
                    <li>Light microscopy of the kidney biopsy sample revealed refractile oxalate crystals in the tubular lumina and cytoplasm</li>
                    <li>
                        Additional kidney damage was noted
                        <ul class="list-inside list-['-_'] pl-6">
                            <li>Three glomeruli out of the seven in the biopsy were globally sclerosed</li>
                            <li>Tubules showed prominent cytoplasmic vacuolar changes and severe acute injury with epithelial simplification and loss of brush borders</li>
                            <li>Interstitial fibrosis and atrophy involved ~40% of the sampled cortex</li>
                        </ul>
                    </li>
                </ul>

                
            </div>

            <div class="flex-1">
                <p class="font-semibold">Extensive refractile oxalate crystals in the tubular lumina</p>

                <img
                    src="@/assets/img/graphics/postpartum/oxalate-crystals.png"
                    alt="Oxalate crystals"
                    class="object-contain w-full"
                />
                <div class="flex items-center space-x-2 ml-4">
                    <img
                        src="@/assets/img/graphics/postpartum/pink-dot.svg"
                        alt="Dot icon for map legend"
                        class=""
                    />
                    <p class="p-5 font-semibold">Oxalate crystals</p>

                </div>
            </div>
        </div>
    </div>
</template>
